import React from 'react';

import { BREAK_POINT } from 'constants/responsive';

import picIcon from 'assets/images/pic-icon.png';

import './CarouselSlide.sass';

interface ISlideProps {
    key: string;
    bold_text: string;
    sub_text: string;
    className?: string;
    link: string;
}

const CarouselSlide: React.StatelessComponent<ISlideProps> = (props: ISlideProps) => {
    return (
        <a href={props.link} className={`Carousel-slide${window.innerWidth < BREAK_POINT ? '-mobile' : ''}${props.className ? ` ${props.className}` : ''}`}>
            <div className="Pic-icon"><img className="img-responsive" src={picIcon} /></div>
            <div className="Slide-text">
                <div className="Slide-text-bold">{props.bold_text}</div>
                <div className="Slide-text-sub">{props.sub_text}</div>
            </div>
        </a>
    );
};

export default CarouselSlide;



// WEBPACK FOOTER //
// ./src/components/global/application/footer/CarouselSlide.tsx